// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DocumentEditorDetailFragmentDoc } from '../../../../fragments/circularFragments.generated';
import { DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ExpensesTableByProjectIdQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  onlyAllocated?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  onlyUnallocated?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type ExpensesTableByProjectIdQuery = { __typename?: 'Query', expensesPage: { __typename?: 'ExpensesPage', entities: Array<{ __typename?: 'Expense', id: string, intacctApBillId: string, amountInCents: number, expenseDate: Types.Scalars['Date']['input'], description: string, intacctVendorName: string, isBrex: boolean, amountPaidInCents: number, unallocatedAmountInCents: number, intacctVendorId: string, canBeConvertedToBill: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, documents: Array<{ __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, parent:
          | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
              > }> | null | undefined }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
        , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, costCode?: { __typename?: 'CostCode', number: string, id: string, displayName: string } | null | undefined, stage: { __typename?: 'StageDetail', code: Types.Stage }, project:
        | { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      , changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus, totalCostInCents: number, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }>, potentialProjectItems: Array<{ __typename?: 'ProjectItem', id: string, displayName: string, uncommittedBudgetAmountInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } }, budgetFinancials: { __typename?: 'ProjectItemBudgetFinancials', revisedInternalBudget: number, committed: number, uncommitted: number, tradeBilled: number }, signedCommitmentLineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, owner:
            | { __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
            | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
           }> }>, allocations: Array<{ __typename?: 'ExpenseAllocation', id: string, amountInCents: number, projectItem: { __typename?: 'ProjectItem', id: string }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined }> }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } };

export type SaveDocumentsToExpenseMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  documents?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
}>;


export type SaveDocumentsToExpenseMutation = { __typename?: 'Mutation', saveExpenses: { __typename?: 'SaveExpensesResult', expenses: Array<{ __typename?: 'Expense', id: string }> } };

export type SaveExpenseTableDocumentMutationVariables = Types.Exact<{
  input: Types.SaveDocumentInput;
}>;


export type SaveExpenseTableDocumentMutation = { __typename?: 'Mutation', saveDocuments: { __typename?: 'SaveDocumentsResult', documents: Array<{ __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string }
        | { __typename?: 'Community', id: string, name: string }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      >, parent:
        | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }> | null | undefined }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
      , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type SaveExpenseMutationVariables = Types.Exact<{
  input: Types.SaveExpenseInput;
}>;


export type SaveExpenseMutation = { __typename?: 'Mutation', saveExpenses: { __typename?: 'SaveExpensesResult', expenses: Array<{ __typename?: 'Expense', id: string, intacctApBillId: string, amountInCents: number, expenseDate: Types.Scalars['Date']['input'], description: string, intacctVendorName: string, isBrex: boolean, amountPaidInCents: number, unallocatedAmountInCents: number, intacctVendorId: string, canBeConvertedToBill: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, documents: Array<{ __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        >, parent:
          | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
                | { __typename?: 'StandaloneProject', id: string, name: string }
                | { __typename?: 'Region', id: string, name: string }
                | { __typename?: 'Market', id: string, name: string }
                | { __typename?: 'Community', id: string, name: string }
                | { __typename?: 'Subdivision', id: string, name: string }
                | { __typename?: 'Lot', id: string, name: string }
                | { __typename?: 'Structure', id: string, name: string }
                | { __typename?: 'Unit', id: string, name: string }
              > }> | null | undefined }
          | { __typename?: 'PlanPackage', id: string }
          | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
          | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
              | { __typename?: 'StandaloneProject', id: string, name: string }
              | { __typename?: 'Region', id: string, name: string }
              | { __typename?: 'Market', id: string, name: string }
              | { __typename?: 'Community', id: string, name: string }
              | { __typename?: 'Subdivision', id: string, name: string }
              | { __typename?: 'Lot', id: string, name: string }
              | { __typename?: 'Structure', id: string, name: string }
              | { __typename?: 'Unit', id: string, name: string }
            > }
        , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, costCode?: { __typename?: 'CostCode', number: string, id: string, displayName: string } | null | undefined, stage: { __typename?: 'StageDetail', code: Types.Stage }, project:
        | { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
        | { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
      , changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus, totalCostInCents: number, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }>, potentialProjectItems: Array<{ __typename?: 'ProjectItem', id: string, displayName: string, uncommittedBudgetAmountInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } }, budgetFinancials: { __typename?: 'ProjectItemBudgetFinancials', revisedInternalBudget: number, committed: number, uncommitted: number, tradeBilled: number }, signedCommitmentLineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, owner:
            | { __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
            | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
           }> }>, allocations: Array<{ __typename?: 'ExpenseAllocation', id: string, amountInCents: number, projectItem: { __typename?: 'ProjectItem', id: string }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined }> }> } };

export type SaveExpenseAllocationsMutationVariables = Types.Exact<{
  input: Types.SaveExpenseAllocationsInput;
}>;


export type SaveExpenseAllocationsMutation = { __typename?: 'Mutation', saveExpenseAllocations: { __typename?: 'SaveExpenseAllocationsResult', expenseAllocations: Array<{ __typename?: 'ExpenseAllocation', id: string, amountInCents: number, expense: { __typename?: 'Expense', id: string, amountInCents: number, changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }> }, projectItem: { __typename?: 'ProjectItem', id: string } }> } };

export type ConvertExpenseToBillMutationVariables = Types.Exact<{
  input: Types.ConvertExpenseToBillInput;
}>;


export type ConvertExpenseToBillMutation = { __typename?: 'Mutation', convertExpenseToBill: { __typename?: 'ConvertExpenseToBillResult', bill: { __typename?: 'Bill', id: string } } };

export type ExpensesTable_ExpenseFragment = { __typename?: 'Expense', id: string, intacctApBillId: string, amountInCents: number, expenseDate: Types.Scalars['Date']['input'], description: string, intacctVendorName: string, isBrex: boolean, amountPaidInCents: number, unallocatedAmountInCents: number, intacctVendorId: string, canBeConvertedToBill: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, documents: Array<{ __typename?: 'Document', name: string, sizeInBytes: number, attachOn: Array<Types.DocumentAttachmentPlace>, id: string, category: Types.DocumentCategory, createdAt: Types.Scalars['DateTime']['input'], displayName: string, homeownerVisible: boolean, isDeleted?: boolean | null | undefined, isFavorited: boolean, issuanceDate?: Types.Scalars['Date']['input'] | null | undefined, canArchive: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, categoryDetail?: { __typename?: 'DocumentCategoryDetail', name: string, code: Types.DocumentCategory } | null | undefined, followers: Array<{ __typename?: 'InternalUser', id: string }>, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }, assets: Array<{ __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined }>, createdBy: { __typename?: 'User', id: string, name: string }, tasks: Array<{ __typename?: 'Task', id: string }>, associatedProjects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, parent:
      | { __typename?: 'Development', id: string, name: string, cohorts?: Array<{ __typename?: 'Cohort', id: string, name: string, projects: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }> | null | undefined }
      | { __typename?: 'PlanPackage', id: string }
      | { __typename?: 'StandaloneProject', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Region', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Market', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Community', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Subdivision', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Lot', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Structure', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
      | { __typename?: 'Unit', id: string, name: string, childrenRecursive: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }
    , documentType: { __typename?: 'DocumentTypeDetail', code: Types.DocumentType, name: string, systemControlled: boolean }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }>, costCode?: { __typename?: 'CostCode', number: string, id: string, displayName: string } | null | undefined, stage: { __typename?: 'StageDetail', code: Types.Stage }, project:
    | { __typename?: 'StandaloneProject', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Region', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Market', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Community', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Subdivision', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Lot', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Structure', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
    | { __typename?: 'Unit', id: string, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, clientNoun: string } }
  , changeEvents: Array<{ __typename?: 'ChangeEvent', id: string, status: Types.ChangeEventStatus, totalCostInCents: number, lineItems: Array<{ __typename?: 'ChangeEventLineItem', id: string, projectItem: { __typename?: 'ProjectItem', id: string } }> }>, potentialProjectItems: Array<{ __typename?: 'ProjectItem', id: string, displayName: string, uncommittedBudgetAmountInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } }, budgetFinancials: { __typename?: 'ProjectItemBudgetFinancials', revisedInternalBudget: number, committed: number, uncommitted: number, tradeBilled: number }, signedCommitmentLineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, owner:
        | { __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
        | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
       }> }>, allocations: Array<{ __typename?: 'ExpenseAllocation', id: string, amountInCents: number, projectItem: { __typename?: 'ProjectItem', id: string }, commitmentLineItem?: { __typename?: 'CommitmentLineItem', id: string } | null | undefined }> };

export type ExpensesTable_PotentialProjectItemsFragment = { __typename?: 'ProjectItem', id: string, displayName: string, uncommittedBudgetAmountInCents: number, item: { __typename?: 'Item', id: string, costCode: { __typename?: 'CostCode', id: string } }, budgetFinancials: { __typename?: 'ProjectItemBudgetFinancials', revisedInternalBudget: number, committed: number, uncommitted: number, tradeBilled: number }, signedCommitmentLineItems: Array<{ __typename?: 'CommitmentLineItem', id: string, owner:
      | { __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
      | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
     }> };

export type ExpensesTable_CommitmentLineItemFragment = { __typename?: 'CommitmentLineItem', id: string, owner:
    | { __typename?: 'Commitment', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
    | { __typename?: 'CommitmentChangeOrder', id: string, displayName: string, accountingNumber: number, tradePartner?: { __typename?: 'TradePartner', id: string, intacctId?: string | null | undefined } | null | undefined }
   };

export type ExpensesTable_ProjectItemBudgetFinancialsFragment = { __typename?: 'ProjectItemBudgetFinancials', revisedInternalBudget: number, committed: number, uncommitted: number, tradeBilled: number };

export const ExpensesTable_ProjectItemBudgetFinancialsFragmentDoc = gql`
    fragment ExpensesTable_ProjectItemBudgetFinancials on ProjectItemBudgetFinancials {
  revisedInternalBudget
  committed
  uncommitted
  tradeBilled
}
    `;
export const ExpensesTable_CommitmentLineItemFragmentDoc = gql`
    fragment ExpensesTable_CommitmentLineItem on CommitmentLineItem {
  id
  owner {
    id
    displayName
    accountingNumber
    tradePartner {
      id
      intacctId
    }
  }
}
    `;
export const ExpensesTable_PotentialProjectItemsFragmentDoc = gql`
    fragment ExpensesTable_PotentialProjectItems on ProjectItem {
  id
  displayName
  uncommittedBudgetAmountInCents
  item {
    id
    costCode {
      id
    }
  }
  budgetFinancials {
    ...ExpensesTable_ProjectItemBudgetFinancials
  }
  signedCommitmentLineItems {
    ...ExpensesTable_CommitmentLineItem
  }
}
    ${ExpensesTable_ProjectItemBudgetFinancialsFragmentDoc}
${ExpensesTable_CommitmentLineItemFragmentDoc}`;
export const ExpensesTable_ExpenseFragmentDoc = gql`
    fragment ExpensesTable_Expense on Expense {
  id
  intacctApBillId
  amountInCents
  expenseDate
  description
  canBeConvertedToBill {
    allowed
    disabledReasons {
      message
    }
  }
  documents {
    ...DocumentEditorDetail
  }
  costCode {
    ...DisplayNamed
    number
  }
  intacctVendorName
  isBrex
  amountPaidInCents
  unallocatedAmountInCents
  stage {
    code
  }
  project {
    id
    lotType {
      code
      clientNoun
    }
  }
  changeEvents {
    id
    status
    totalCostInCents
    lineItems {
      id
      projectItem {
        id
      }
    }
  }
  potentialProjectItems {
    ...ExpensesTable_PotentialProjectItems
  }
  allocations {
    id
    amountInCents
    projectItem {
      id
    }
    commitmentLineItem {
      id
    }
  }
  stage {
    code
  }
  intacctVendorId
}
    ${DocumentEditorDetailFragmentDoc}
${DisplayNamedFragmentDoc}
${ExpensesTable_PotentialProjectItemsFragmentDoc}`;
export const ExpensesTableByProjectIdDocument = gql`
    query ExpensesTableByProjectId($projectId: ID!, $onlyAllocated: Boolean, $onlyUnallocated: Boolean, $page: PageFilter) {
  expensesPage(
    filter: {projectId: [$projectId], allocated: $onlyAllocated, unallocated: $onlyUnallocated}
    page: $page
  ) {
    entities {
      ...ExpensesTable_Expense
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${ExpensesTable_ExpenseFragmentDoc}`;

/**
 * __useExpensesTableByProjectIdQuery__
 *
 * To run a query within a React component, call `useExpensesTableByProjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useExpensesTableByProjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExpensesTableByProjectIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      onlyAllocated: // value for 'onlyAllocated'
 *      onlyUnallocated: // value for 'onlyUnallocated'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useExpensesTableByProjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables> & ({ variables: ExpensesTableByProjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>(ExpensesTableByProjectIdDocument, options);
      }
export function useExpensesTableByProjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>(ExpensesTableByProjectIdDocument, options);
        }
// @ts-ignore
export function useExpensesTableByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>;
export function useExpensesTableByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ExpensesTableByProjectIdQuery | undefined, ExpensesTableByProjectIdQueryVariables>;
export function useExpensesTableByProjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>(ExpensesTableByProjectIdDocument, options);
        }
export type ExpensesTableByProjectIdQueryHookResult = ReturnType<typeof useExpensesTableByProjectIdQuery>;
export type ExpensesTableByProjectIdLazyQueryHookResult = ReturnType<typeof useExpensesTableByProjectIdLazyQuery>;
export type ExpensesTableByProjectIdSuspenseQueryHookResult = ReturnType<typeof useExpensesTableByProjectIdSuspenseQuery>;
export type ExpensesTableByProjectIdQueryResult = Apollo.QueryResult<ExpensesTableByProjectIdQuery, ExpensesTableByProjectIdQueryVariables>;
export const SaveDocumentsToExpenseDocument = gql`
    mutation SaveDocumentsToExpense($id: ID!, $documents: [ID!]) {
  saveExpenses(input: {expenses: [{id: $id, documents: $documents}]}) {
    expenses {
      id
    }
  }
}
    `;
export type SaveDocumentsToExpenseMutationFn = Apollo.MutationFunction<SaveDocumentsToExpenseMutation, SaveDocumentsToExpenseMutationVariables>;

/**
 * __useSaveDocumentsToExpenseMutation__
 *
 * To run a mutation, you first call `useSaveDocumentsToExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentsToExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentsToExpenseMutation, { data, loading, error }] = useSaveDocumentsToExpenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      documents: // value for 'documents'
 *   },
 * });
 */
export function useSaveDocumentsToExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDocumentsToExpenseMutation, SaveDocumentsToExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDocumentsToExpenseMutation, SaveDocumentsToExpenseMutationVariables>(SaveDocumentsToExpenseDocument, options);
      }
export type SaveDocumentsToExpenseMutationHookResult = ReturnType<typeof useSaveDocumentsToExpenseMutation>;
export type SaveDocumentsToExpenseMutationResult = Apollo.MutationResult<SaveDocumentsToExpenseMutation>;
export type SaveDocumentsToExpenseMutationOptions = Apollo.BaseMutationOptions<SaveDocumentsToExpenseMutation, SaveDocumentsToExpenseMutationVariables>;
export const SaveExpenseTableDocumentDocument = gql`
    mutation SaveExpenseTableDocument($input: SaveDocumentInput!) {
  saveDocuments(input: {documents: [$input]}) {
    documents {
      ...DocumentEditorDetail
    }
  }
}
    ${DocumentEditorDetailFragmentDoc}`;
export type SaveExpenseTableDocumentMutationFn = Apollo.MutationFunction<SaveExpenseTableDocumentMutation, SaveExpenseTableDocumentMutationVariables>;

/**
 * __useSaveExpenseTableDocumentMutation__
 *
 * To run a mutation, you first call `useSaveExpenseTableDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExpenseTableDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExpenseTableDocumentMutation, { data, loading, error }] = useSaveExpenseTableDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveExpenseTableDocumentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveExpenseTableDocumentMutation, SaveExpenseTableDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveExpenseTableDocumentMutation, SaveExpenseTableDocumentMutationVariables>(SaveExpenseTableDocumentDocument, options);
      }
export type SaveExpenseTableDocumentMutationHookResult = ReturnType<typeof useSaveExpenseTableDocumentMutation>;
export type SaveExpenseTableDocumentMutationResult = Apollo.MutationResult<SaveExpenseTableDocumentMutation>;
export type SaveExpenseTableDocumentMutationOptions = Apollo.BaseMutationOptions<SaveExpenseTableDocumentMutation, SaveExpenseTableDocumentMutationVariables>;
export const SaveExpenseDocument = gql`
    mutation SaveExpense($input: SaveExpenseInput!) {
  saveExpenses(input: {expenses: [$input]}) {
    expenses {
      ...ExpensesTable_Expense
    }
  }
}
    ${ExpensesTable_ExpenseFragmentDoc}`;
export type SaveExpenseMutationFn = Apollo.MutationFunction<SaveExpenseMutation, SaveExpenseMutationVariables>;

/**
 * __useSaveExpenseMutation__
 *
 * To run a mutation, you first call `useSaveExpenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExpenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExpenseMutation, { data, loading, error }] = useSaveExpenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveExpenseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveExpenseMutation, SaveExpenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveExpenseMutation, SaveExpenseMutationVariables>(SaveExpenseDocument, options);
      }
export type SaveExpenseMutationHookResult = ReturnType<typeof useSaveExpenseMutation>;
export type SaveExpenseMutationResult = Apollo.MutationResult<SaveExpenseMutation>;
export type SaveExpenseMutationOptions = Apollo.BaseMutationOptions<SaveExpenseMutation, SaveExpenseMutationVariables>;
export const SaveExpenseAllocationsDocument = gql`
    mutation SaveExpenseAllocations($input: SaveExpenseAllocationsInput!) {
  saveExpenseAllocations(input: $input) {
    expenseAllocations {
      id
      amountInCents
      expense {
        id
        amountInCents
        changeEvents {
          id
          status
          lineItems {
            id
            projectItem {
              id
            }
          }
        }
      }
      projectItem {
        id
      }
    }
  }
}
    `;
export type SaveExpenseAllocationsMutationFn = Apollo.MutationFunction<SaveExpenseAllocationsMutation, SaveExpenseAllocationsMutationVariables>;

/**
 * __useSaveExpenseAllocationsMutation__
 *
 * To run a mutation, you first call `useSaveExpenseAllocationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveExpenseAllocationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveExpenseAllocationsMutation, { data, loading, error }] = useSaveExpenseAllocationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveExpenseAllocationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveExpenseAllocationsMutation, SaveExpenseAllocationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveExpenseAllocationsMutation, SaveExpenseAllocationsMutationVariables>(SaveExpenseAllocationsDocument, options);
      }
export type SaveExpenseAllocationsMutationHookResult = ReturnType<typeof useSaveExpenseAllocationsMutation>;
export type SaveExpenseAllocationsMutationResult = Apollo.MutationResult<SaveExpenseAllocationsMutation>;
export type SaveExpenseAllocationsMutationOptions = Apollo.BaseMutationOptions<SaveExpenseAllocationsMutation, SaveExpenseAllocationsMutationVariables>;
export const ConvertExpenseToBillDocument = gql`
    mutation ConvertExpenseToBill($input: ConvertExpenseToBillInput!) {
  convertExpenseToBill(input: $input) {
    bill {
      id
    }
  }
}
    `;
export type ConvertExpenseToBillMutationFn = Apollo.MutationFunction<ConvertExpenseToBillMutation, ConvertExpenseToBillMutationVariables>;

/**
 * __useConvertExpenseToBillMutation__
 *
 * To run a mutation, you first call `useConvertExpenseToBillMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConvertExpenseToBillMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [convertExpenseToBillMutation, { data, loading, error }] = useConvertExpenseToBillMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConvertExpenseToBillMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConvertExpenseToBillMutation, ConvertExpenseToBillMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConvertExpenseToBillMutation, ConvertExpenseToBillMutationVariables>(ConvertExpenseToBillDocument, options);
      }
export type ConvertExpenseToBillMutationHookResult = ReturnType<typeof useConvertExpenseToBillMutation>;
export type ConvertExpenseToBillMutationResult = Apollo.MutationResult<ConvertExpenseToBillMutation>;
export type ConvertExpenseToBillMutationOptions = Apollo.BaseMutationOptions<ConvertExpenseToBillMutation, ConvertExpenseToBillMutationVariables>;